import { render, staticRenderFns } from "./FilterSync.vue?vue&type=template&id=66d78d06&"
import script from "./FilterSync.vue?vue&type=script&lang=js&"
export * from "./FilterSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports